import { Component, Injectable, NgZone } from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController, ToastController, LoadingController, AlertController, NavParams } from 'ionic-angular';

import { EinsatzplanData } from '../../providers/einsatzplan-data';
import { EinsatzplanDetailPage } from './einsatzplan-detail';
import { UserData } from '../../providers/user-data';
import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import { KontrolleData } from '../../providers/kontrolle-data';
import { ParplatzData } from '../../providers/pp-data';
import { CompletePPService } from '../../providers/epautocomplete-service';
import moment from 'moment';
import { EmployeeavalabilityData } from '../employeeavailability/employeeavailability-data';


@Component({
  selector: 'einsatzplan-list',
  templateUrl: 'einsatzplan-list.html'
})
export class EinsatzplanListPage {
  actionSheet: ActionSheet;
  einsatzplan = [];
  planingdata = [];
  viewmode = "planned";
  command;
  dBegin;
  dEnd;
  maxDate;
  minDate;  
  constructor( public common: CommonData
              , public actionSheetCtrl: ActionSheetController
              , public navCtrl: NavController
              , private navParams: NavParams
              , public http: Http
              , public einsatzplanData: EinsatzplanData
              , public eaData: EmployeeavalabilityData
              , public config: Config
              , public userData: UserData
              , public ppData: ParplatzData
              , public kontrolleData: KontrolleData
              , public loadingCtrl: LoadingController
              , public toastCtrl: ToastController
              , public alertCtrl: AlertController
              , public completePPService: CompletePPService
              , public zone: NgZone
              ){
        einsatzplanData.viewmode = this.viewmode;

        if(navParams.data.datum){
          let d = moment(navParams.data.datum);
          //d.add(1, "day");
          d.set({hour:0,minute:0,second:0,millisecond:0})
          d.set({hour:navParams.data.zeit.split(':')[0],minute:navParams.data.zeit.split(':')[1],second:0,millisecond:0})        ;
          //d.subtract(1, "minutes");
          this.dBegin = d.toISOString(true);    
          d.set({hour:navParams.data.zeit.split(':')[0],minute:navParams.data.zeit.split(':')[1],second:0,millisecond:0})        ;
          //d.add(1, "minutes");
          console.log(this.dBegin);
          this.dEnd = d.toISOString(true);    
          console.log(this.dEnd);
          this.command ="existingEpEntries";    
          this.zone.run(() => {       
            this.viewmode = 'planing';    
            this.executeAction();      
          });          
          

        }
        else{
          let d = moment();
          //d.add(1, "day");
          d.set({hour:0,minute:0,second:0,millisecond:0})
          this.dBegin = d.toISOString(true);    
          d.add(5, "day");  
          d.set({hour:23,minute:59,second:0,millisecond:0})        
          this.dEnd = d.toISOString(true);    
          this.command ="existingEpEntries";    
          
        }
        this.minDate = moment.utc().startOf('day').format('YYYY-MM-DD');
        this.maxDate = moment.utc().add(2, 'y').format('YYYY-MM-DD');   

        einsatzplanData.updateRequired = true; 
  }

  ionViewWillEnter() {
    this.eaData.loadTimeSlots();
    if(this.einsatzplanData.updateRequired){
      Promise.all([    
          this.einsatzplanData.load(),            
        ]).then(data => {
          this.einsatzplan = this.einsatzplanData.data;           
        });

    }
  }  

  assignUser(user_id, time, ep){
    ep.fkuser = user_id;
    ep.dDatum = ep.datum+"T"+time;
  }
  executeAction(){


    var data = JSON.stringify({
      dBegin: this.dBegin,
      dEnd: this.dEnd,
      token: this.userData.jwt
    });
    if(this.viewmode =="planing"){
      if(this.command == "existingEpEntries"){
        Promise.all([
          this.einsatzplanData.extendedep(data),            
        ]).then(data => {
          let tmpdata = this.einsatzplanData.dataextended;
          if(!tmpdata){
            return false;
          }
          for(let i=0; i<tmpdata.length; i++){
            tmpdata[i]["dDatum"] = tmpdata[i]["datum"]+"T"+tmpdata[i]["sollzeit"];
          }
          //console.log(tmpdata);
          this.planingdata = tmpdata;   

          this.planingdata.forEach((ep,index) => {
            this.planingdata[index].removedkontids = [];
            this.planingdata[index].addedkontids = [];
          });
          
          //this.einsatzplan = this.einsatzplanData.data;      
          //refresh.complete();     
        }); 

      }
      else if(this.command == "createEpEntries"){
        let loading = this.loadingCtrl.create({
          content: 'Planung wird vorbereitet, bitte warten...'
        });
        loading.present();        
        //-- Timeout falls Promise nie auflöst -----
        let loadingTimeout = setTimeout(() => {
          loading.dismiss();

          let toast = this.toastCtrl.create({
            message: "Planung fehlgeschlagen",
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });

          toast.present();             
        }, 120000);

        Promise.all([
          this.einsatzplanData.createmultiple(data),            
        ]).then(data => {
          loading.dismiss();
          clearTimeout(loadingTimeout);
          //console.log("createmultiple data:");
          //console.log(data);
          //console.log(data.length);
          //this.einsatzplanData.dataextended = data;
          let tmpdata = this.einsatzplanData.dataextended;
          if(!tmpdata){
            return false;
          }
          for(let i=0; i<tmpdata.length; i++){
            tmpdata[i]["dDatum"] = tmpdata[i]["datum"]+"T"+tmpdata[i]["sollzeit"];
          }
          //console.log(tmpdata);
          this.planingdata = tmpdata;   

          this.planingdata.forEach((ep,index) => {
            this.planingdata[index].removedkontids = [];
            this.planingdata[index].addedkontids = [];
          });
        });  

      }
      else if(this.command == "addManual"){
        let loading = this.loadingCtrl.create({
          content: 'Manuelle Planung wird vorbereitet, bitte warten...'
        });
        loading.present();        
        //-- Timeout falls Promise nie auflöst -----
        let loadingTimeout = setTimeout(() => {
          loading.dismiss();

          let toast = this.toastCtrl.create({
            message: "Manuelle Planung fehlgeschlagen",
            position: 'top',
            cssClass: 'toast-error',
            duration: 3000
          });

          toast.present();             
        }, 30000);

        Promise.all([
          this.einsatzplanData.createmanual(data),            
        ]).then(data => {
          loading.dismiss();
          clearTimeout(loadingTimeout);
          //-- Einträge neu laden ------
          this.dEnd = this.dBegin;
          this.command = 'existingEpEntries';
          this.executeAction();           
        });  
      }      
      
    }

  }
  cancelextendedep(extendedep){
    //console.log(extendedep);
    let title = "";
    let param: any;
     /*
     if(Array.isArray(kont)){
       title = "Soll die Kontrolle wirklich storniert werden?";
       param = kont;
       
     }
     else{
       title = "Soll die Kontrolle des Parkplatzes '"+kont.kurzname+"' wirklich storniert werden?";
       param = {pp1 : kont};
     }
    */
    title = "Soll die Kontrolle wirklich storniert werden?";
     let alert = this.alertCtrl.create();
     alert.setTitle(title);
     alert.setSubTitle('Grund:');
     alert.addInput({
         type: 'textarea',
         label: 'Grund',
         
     });

     alert.addButton('Abbrechen');
     alert.addButton({
       text: 'Ja',
       handler: (data: any) => {
           this.stornoEinsatzplan(extendedep.kontids, data[0]);
           //this.testCheckboxOpen = false;
       }
     });

     alert.present();    
  }


  stornoEinsatzplan(kont,reason){
      
       Promise.all([
           this.einsatzplanData.sotrno(kont, reason),            
         ]).then(data => {
           //console.log(data);
           let toast = this.toastCtrl.create({
            message: "Kontrolle erfolgreich storniert",
            position: 'top',
            cssClass: 'toast-error',
            duration: 3000
          });
          this.command == "existingEpEntries";
          this.executeAction();

          toast.present(); 
           //this.einsatzplan = this.einsatzplanData.data;      
         });   
  }

  removePP(epindex, ppindex){
    this.planingdata[epindex].removedkontids.push(this.planingdata[epindex].kontids[ppindex]);
    this.planingdata[epindex].kontids.splice(ppindex, 1); 

  }
  addPP(epindex, ppindex){
    //console.log(this.planingdata[epindex]);
    this.planingdata[epindex].kontids.push(this.planingdata[epindex].removedkontids[ppindex]);
    this.planingdata[epindex].removedkontids.splice(ppindex, 1); 
  }
  newPPSelected(event, epindex){
    let bpppresent = false;
    this.planingdata[epindex].kontids.forEach((ep,index) => {
      if(ep.fkgrundstueck == event.grundid){
        bpppresent = true;
      }
    });
    if(bpppresent){
      let toast = this.toastCtrl.create({
        message: "Parkplatz bereits vorhanden",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();         
    }
    else{
      this.planingdata[epindex].addedkontids.push({fkgrundstueck:event.grundid});

    }
  }  
  removeNewPP(epindex, ppindex){
    //this.planingdata[epindex].removedkontids.push(this.planingdata[epindex].kontids[ppindex]);
    this.planingdata[epindex].addedkontids.splice(ppindex, 1); 

  }
  updateextendedep(extendedep){
    var data = JSON.stringify({
      extendedep: extendedep,
      token: this.userData.jwt
    });
    Promise.all([
      this.einsatzplanData.updateextendedep(data),            
    ]).then(data => {
      //console.log("update complete");
      let toast = this.toastCtrl.create({
        message: "Änderung gespeichert",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();          
      /*
      let tmpdata = this.einsatzplanData.dataextended;
      for(let i=0; i<tmpdata.length; i++){
        tmpdata[i]["dDatum"] = tmpdata[i]["datum"]+"T"+tmpdata[i]["sollzeit"];
      }
      this.planingdata = tmpdata;  
      */
 
    });  
  }
  updateEpDate($event, ep){
    ep.sollzeit = moment(ep.dDatum).utc().format("H:mm");
    ep.datum = moment(ep.dDatum).format("YYYY-MM-DD");
    //console.log(ep);
  }
  doRefresh(refresh){
        if(this.viewmode != "planing"){
          this.einsatzplanData.viewmode = this.viewmode;
          Promise.all([
              this.einsatzplanData.load(),            
            ]).then(data => {
              //console.log(data);
              this.einsatzplan = this.einsatzplanData.data;    
              if(refresh && (typeof refresh.complete === "function")){
                refresh.complete();     
              }  
            });    
        }


    
  }  
  
  showEinsatzplanDetail(kontrolle) {
    if(!this.common.wifierror){
      this.navCtrl.push(EinsatzplanDetailPage, kontrolle,{animate: true, animation: 'ios-transition'});
    }
    else{
      this.common.showWifiError(); 
    }
  }





}



// WEBPACK FOOTER //
// ./src/pages/einsatzplan/einsatzplan-list.ts